import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {Subject} from 'rxjs';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FileManagementService} from '@core/services/file-management.service';
import {PlatformQuery, PlatformQueryResponse} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {FlexSheetService} from '@features/spreadsheet/services/flex-sheet.service';
import {FlowChartDataService} from '@features/data-survey/services/flow-chart-data.service';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {EventStatus} from "@shared/models/notification-message.model";


@Injectable({
  providedIn: 'root',
})
export class PlatformToolEmailBlastHandler implements IPlatformToolHandler {
  magicLinkModel: MagicLinkModel;
  selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  invalidateSubject: InvalidateSubject;
  flexSheetService: FlexSheetService;

  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private flowchartDataService: FlowChartDataService,
              protected store: Store<IQueryState>,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private platformQueryService: PlatformQueryService,
              private queryState: Store<IQueryState>
  ) {
    this.invalidateSubject = new InvalidateSubject();
  }

  executeCommand(command: PlatformCommand) {
    this.executeCommandApi(command);
  }

  executeCommandApi(command: PlatformCommand) {
    console.log('[Excel] Executing PlatformCommand : ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      let commandName = command.name;
      const fieldValues = command.fieldValues;
      if (commandName === 'AddEventSourceModelCommand') {
        commandName = command.fieldValues['CommandName'];
      }

      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[Excel] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['DownloadUrl'] && commandResponse.fieldValues['FileName']) {
            this.fileManagementService.downloadOneTimeSignedUrl(commandResponse.fieldValues['DownloadUrl'], commandResponse.fieldValues['FileName']);
            return;
          }

          if (commandResponse.fieldValues['SnackBarMessage']) {
            if (commandResponse.status === EventStatus.Success) {
              this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage']);
            } else {
              this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
            }
          }

         if (commandResponse.fieldValues['ShowWarning']) {
            this.snackBarService.showWarning(commandResponse.fieldValues['ShowWarning']);
          }
          if (commandResponse.fieldValues['ShowErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['ShowErrorMessage']);
          }
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          } else if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
            return;
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }


  magicLinkModelValueChangedHandler(payload: any) {
    this.magicLinkModelValueChanged.emit(payload);
  }

  private handleActions($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'Delete': {
        const command = this.magicLinkModel?.additionalCommands['DeleteCommand'];
        command.fieldValues['EmailRecipientId'] = $event.item.id;
        command.fieldValues['EmailBlastId'] = $event.item.id;
        this.executeCommandApi(command);
      }
        break;
      case 'Edit':
        this.openEditor($event);
        break;
      default:
        if (this.magicLinkModel.additionalCommands[$event.action.id]) {
          const command = this.magicLinkModel.additionalCommands[$event.action.id];
          command.fieldValues['EmailBlastId'] = $event.item.id;
          this.executeCommandApi(command);
        }
        break;
    }
  }

  valueChanged($event) {
    console.log('[Excel] Inside Handler', $event);
    if ($event.action) {
      this.handleActions($event);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key) {
      if ($event.fieldDefinition.key === 'Email') {
        this.openDialogGrid($event);
      } else {
        const url = 'admin-panel/email-blast/' + $event.item.id;
        this.router.navigateByUrl(url);
      }
      // const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
      // command.fieldValues['EmailBlastId'] = $event.item.id;
      // this.executeCommandApi(command);
    }
  }

  private openEditor(event: any, type: string = '') {
    const sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    const minWidth = '800px';
    const maxWidth = '1500px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth,
      sourceType).subscribe(state => {
      if (state.action === 'OK') {
        const value = event.item.cells[event.fieldDefinition.key]?.value;
        let command;

        switch (sourceType) {
          case 'EmailBlast':
            command = this.magicLinkModel?.additionalCommands['UpdateCommand'];
            command.fieldValues['emailBlastId'] = event.item.id;
            break;
          default:
            break;
        }
        const displayText = event.item.cells[event.fieldDefinition.key]?.displayText;
        command.fieldValues['DirtyFieldKey'] = event.fieldDefinition?.key;
        if (displayText) {
          command.fieldValues[event.fieldDefinition.key + 'DisplayText'] = displayText;
        }
        command.fieldValues[event.fieldDefinition.key] = value;
        this.executeCommandApi(command);
      }
      if (state.action === 'OK' && event.fieldDefinition.metaData['SkipUpdate']) {
        this.invalidateSubject.invalidate();
      }
    });
  }

  private openDialogGrid(event: any) {
    let command;
    command = this.magicLinkModel?.additionalCommands['EmailBlastReceipentHitMapCommand'];
    command.fieldValues['ReceipentId'] = event.item.id;
    this.executeCommandApi(command);
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}


